// initial state
const initialState = {
  historyCount: 0,
  isBackButtonClicked: false,
};

export const types = {
  setHistoryCount: 'navigation/setHistoryCount',
  setIsBackButtonClicked: 'navigation/setIsBackButtonClicked',
};

// mutations
const mutations = {
  setHistoryCount(state, historyCount) {
    state.historyCount = historyCount ?? 0;
  },
  setIsBackButtonClicked(state, isBackButtonClicked) {
    state.isBackButtonClicked = isBackButtonClicked ?? false;
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
};
